import { IconButton, LuIcon } from "@overmap-ai/blocks"
import { type ComponentPropsWithRef, memo, type MouseEventHandler, useCallback } from "react"

import { useFallbackEditor, useUndoRedoState } from "../../hooks"
import { tipTapIconMapping } from "../mappings"
import type { OptionalEditorProps } from "../typings"

interface UndoIconButtonProps extends Omit<ComponentPropsWithRef<typeof IconButton>, "children">, OptionalEditorProps {}

export const UndoIconButton = memo<UndoIconButtonProps>((props) => {
	const { ref, onClick, editor: editorFromProps, disabled, ...rest } = props

	const editor = useFallbackEditor(editorFromProps)
	const state = useUndoRedoState(editor)

	const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
		(e) => {
			onClick?.(e)
			if (e.defaultPrevented) return
			editor?.chain().focus().undo().run()
		},
		[editor, onClick],
	)

	return (
		<IconButton ref={ref} onClick={handleClick} disabled={disabled ?? !state?.canUndo} {...rest}>
			<LuIcon icon={tipTapIconMapping.undo} />
		</IconButton>
	)
})
UndoIconButton.displayName = "UndoIconButton"
